import React from "react";
import { useSelector } from "react-redux";
import AreaChart from "../../../../components/charts/areaChart/areaChart";
import BreakdownChartFilter from "./BreakdownChartFilter";

export const detectInterval = (data) => {
  let interval = "preserveEnd";

  data.map((item) => {
    if (item.name.indexOf(" - ") > -1) {
      interval = "preserveStartEnd";
    } else {
      interval = Math.floor(data.length * 0.08);
    }
  });

  return interval;
};

const YearOverYear = () => {
  const { chartData, series } = useSelector((state) => state.serviceBookings.graphData);
  const selectedView = useSelector((state) => state.serviceBookings.selectedFilters.view);

  return (
    <>
      <div className="chart-header">
        <h2>Service Bookings Breakdown</h2>
        <div className="breakdown-filters">
          <BreakdownChartFilter filterKey="period_type" placeholder="Select Period Type" />
          <BreakdownChartFilter filterKey="view" placeholder="Select View" />
        </div>
      </div>
      <AreaChart
        chartData={chartData}
        interval={detectInterval(chartData)}
        right={80}
        left={80}
        width={1350}
        currencySymbol=""
        hasRawData
        showDecimals
        hideLegend
        tooltipName={selectedView.id === "bookings_status" ? null : "Service Bookings"}
        margin={{ top: 5, right: 60, left: 5, bottom: 5 }}
        cartesianGridVerticalPoints={(width) => [width - 60]}
        series={series}
      />
    </>
  );
};

export default YearOverYear;
